import React from 'react'
import { Button, Typography } from '@telavita-core/react-design-kit'
import { format, parseISO } from 'date-fns'

import { ReactComponent as SuccessIcon } from 'static/svg/green-check.svg'
import { ReactComponent as CheckmarkIcon } from 'static/svg/icon-checkmark.svg'

import * as S from './styles'

interface SuccessContentProps {
  handleClose: () => void
  patientFullName: string
  oldDate: string
  newDate: string
}

function formatDate(date: string) {
  const formattedDate = parseISO(date)
  const day = format(formattedDate, 'dd/MM')
  const time = format(formattedDate, 'HH:mm')

  return `${day} às ${time}`
}

export const SuccessContent: React.FC<SuccessContentProps> = ({
  handleClose,
  patientFullName,
  oldDate,
  newDate
}) => {
  return (
    <S.Container>
      <SuccessIcon />
      <Typography variant='header4'>
        Reserva remarcada!
      </Typography>

      <Typography variant='content2'>
        Paciente <strong>{patientFullName}</strong>
      </Typography>

      <S.NewReservationInfoWrapper>
        <CheckmarkIcon color='#49C327'/>
        <Typography variant='content3'>
          Remarcou de <strong>{formatDate(oldDate)}</strong> para <strong>{formatDate(newDate)}</strong>
        </Typography>
      </S.NewReservationInfoWrapper>

      <Typography variant='content2' center>
        O paciente receberá email avisando <br />
        que a reserva foi remarcada.
      </Typography>

      <Button variant='contained' onClick={handleClose}>
        Fechar
      </Button>
    </S.Container>
  )
}